import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ConfigureIcon2 = (props: WrappingIconProps) => {
  return (
    <Icon {...props} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.00003C5 8.1046 5.89543 9.00003 7 9.00003H9C10.1046 9.00003 11 8.1046 11 7.00003H20C20.5523 7.00003 21 6.55231 21 6.00003C21 5.44774 20.5523 5.00003 20 5.00003H11C11 3.89546 10.1046 3.00003 9 3.00003H7C5.89543 3.00003 5 3.89546 5 5.00003H4C3.44772 5.00003 3 5.44774 3 6.00003C3 6.55231 3.44772 7.00003 4 7.00003H5ZM9 6.00003V5.00003H7V6.00003V7.00003H9V6.00003ZM4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H12C12 14.1046 12.8954 15 14 15H16C17.1046 15 18 14.1046 18 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H18C18 9.89546 17.1046 9.00003 16 9.00003H14C12.8954 9.00003 12 9.89546 12 11H4ZM3 18C3 17.4477 3.44772 17 4 17H7C7 15.8955 7.89543 15 9 15H11C12.1046 15 13 15.8955 13 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H13C13 20.1046 12.1046 21 11 21H9C7.89543 21 7 20.1046 7 19H4C3.44772 19 3 18.5523 3 18ZM11 18V17H9V18V19H11V18ZM14 13H16V11H14V13Z"
        fill="currentcolor"
      />
    </Icon>
  );
};
